import * as PIXI from "pixi.js";
import _ from "lodash";
import Display from "./Display.js";

export default class SpriteReactive extends PIXI.Sprite
{
    constructor (sp)
    {
        super(null);

        this.sp = sp;
        this.isSelected = false;
        this.createClosure();
        this.build ();
    }

    createClosure ()
    {
    }

    build ()
    {
        this.addChild(this.sp);
    }

    removeIn (delay)
    {
        //setTimeout(() => this.sp.fadeOut(() => this.sp.removeFromParent()), delay);
        if (this.sp.removeIn)
        {
            this.sp.removeIn(delay);
        }
        else
        {
            if (this.sp.parent)
                this.removeChild(this.sp);

            if (this.parent)
            {
                this.parent.removeChild(this);
            }
        }
    }
    changeEmotion (emotion, duration = 0)
    {
        if (this.sp && this.sp.changeEmotion)
            this.sp.changeEmotion(emotion, duration);
    }

    update (payload)
    {
        let prop = payload.prop;

        if (prop === "gravityX")
        {
            this.sp.responsive.params.x.gravity = parseFloat(payload.val);
        }
        else if (prop === "gravityY")
        {
            this.sp.responsive.params.y.gravity = parseFloat(payload.val);
        }
        else if (prop === "x" || prop === "y")
        {
            _.set(this, prop, payload.val);
        }
        else
        {
            _.set(this.sp, prop, payload.val);
        }

        /*if (prop === "x" || prop === "y")
        {
            this.sp[prop] = parseFloat(payload.val);
        }
        else if (prop === "scaleX")
        {
            this.sp.responsive.scale.x = parseFloat(payload.val);
        }
        else if (prop === "scaleY")
        {
            this.sp.responsive.scale.y = parseFloat(payload.val);
        }
        else if (prop === "anchorX")
        {
            this.sp.anchor.x = parseFloat(payload.val);
        }
        else if (prop === "anchorY")
        {
            this.sp.anchor.y = parseFloat(payload.val);
        }
        else if (prop === "gravityX")
        {
            this.sp.responsive.params.x.gravity = parseFloat(payload.val);
        }
        else if (prop === "gravityY")
        {
            this.sp.responsive.params.y.gravity = parseFloat(payload.val);
        }
        else if (prop === "name")
        {
            this.sp.name = payload.val;
        }*/




        const {width,height} = Display.getScreenSize();

        this.sp.layout(width, height);
        this.selected();

        this.dispatch();
    }



    getProps ()
    {
        const {width,height} = Display.getScreenSize();

        let obj = [];
        obj.push( {prop: "name", val: this.sp.name});
        obj.push( {prop: "atlas", val: this.sp.atlas});
        obj.push( {prop: "atlasKey", val: this.sp.atlasKey});
        obj.push( {prop: "x", val: this.sp.x});
        obj.push( {prop: "y", val: this.sp.y});

        obj.push( {prop: "responsive", val: this.sp.responsive});

        obj.push( {prop: "gravityX", val: this.sp.x / width});
        obj.push( {prop: "gravityY", val: this.sp.y / height});

        obj.push( {prop: "scale.x", val: this.sp.responsive.scale.x});
        obj.push( {prop: "scale.y", val: this.sp.responsive.scale.y});
        obj.push( {prop: "scale.relative.x.to", val: this.sp.responsive.scale.relative.x.to});
        obj.push( {prop: "scale.relative.y.to", val: this.sp.responsive.scale.relative.y.to});
        obj.push( {prop: "scale.relative.x.baseValue", val: this.sp.responsive.scale.relative.x.baseValue});
        obj.push( {prop: "scale.relative.y.baseValue", val: this.sp.responsive.scale.relative.y.baseValue});

        obj.push( {prop: "anchor.x", val: this.sp.anchor.x});
        obj.push( {prop: "anchor.y", val: this.sp.anchor.y});
        obj.push( {prop: "index", val: this.parent.getChildIndex(this)});
        obj.push( {prop: "visible", val: this.sp.alpha > 0});
        obj.push( {prop: "interactive", val: this.interactive});

        return obj;
    }

    static getResponsive (props)
    {
        let responsive =  props.find( p => p.prop === "responsive").val;

        return responsive;
    }




    layout (width, height)
    {
        this.sp.layout(width, height);

    }

    fadeIn (duration = 1, delay = 0)
    {
        if (this.sp.fadeIn)
        {
            this.sp.fadeIn(duration, delay);
        }
    }






}
